import { useContext, useEffect, useState } from "react";
import { ButtonBar } from "../molecule/buttonBar";
import { MultipleChoice } from "../molecule/multipleChoice";
import { AssessmentTitle } from "../molecule/assessmentTitle";
import { OrderAnswers } from "../molecule/orderAnswers";
import { MatchChoice } from "../molecule/MatchChoice";
import { TrueFalseChoice } from "../molecule/multipleChoice copy";
import { HorizontalLayout, VerticalLayout } from "./layout";
import { QuizStepper } from "./quizStepper";
import { getAPI, postAPI, updateAPI } from "../api/api";
import { AssessmentFactory } from "../factory/assessmentContentFactory";
import { PageContext, ToastContext } from "../App";
import ImageAssessmentComp from "../components/imageAssessmentComp";
import { Melding } from "../atoms/melding";
import { TimeBar } from "../molecule/timeBar";
import OpenAssessmentComp from "./openAssessmentComp";
import { IconButton, StandardButton } from "../atoms/buttons";
import { icon } from "../functions/icons";
import { ScoreOverviewModal } from "./customModals";
import { VideoPlayerAssessment } from "../atoms/video";

export const AssessmentComp = () => {
  const navigationContext = useContext(PageContext);
  const toastContext = useContext(ToastContext);

  const [assessment, setAssessment] = useState([]);
  const [quizStructure, setQuizStructure] = useState([]);
  const [step, setActiveStep] = useState(0);
  const [, setMatchedPairsState] = useState([]);
  const [message, setMessage] = useState("");
  const [showScoreModal, setShowScoreModal] = useState(false);
  const [animationClass, setAnimationClass] = useState("animate-in");
  const [maxReachedModule, setMaxReachedModule] = useState(0);
  const [avatarVideoMini, setAvatarVideoMini] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const [messageAnimation, setMessageAnimation] = useState("fade-in-top-to-bottom");

  useEffect(() => {
    loadAssessments();
    loadCourseStructure();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadAssessments = async () => {
    const query = `api/assessments?course=${navigationContext.sidebar.courseID}&id_course_enrollments=${navigationContext.sidebar.enrollment}`;
    const assessment = await getAPI(query);
    setAssessment(assessment.data);
    if (assessment.data[0].start_position > 0) {
      setActiveStep(assessment.data[0].start_position - 1);
      return;
    }
    setActiveStep(0);
  };

  const loadCourseStructure = async () => {
    const query = `api/courses/lessons/${navigationContext.sidebar.courseID}/structure`;
    const courseStructure = await getAPI(query);
    courseStructure.data.forEach(course => { course.collapsed = true; });
    let indexCounter = 0;
    courseStructure.data.forEach(lesson => {
      lesson.modules.forEach(module => {
        module.indexCounter = indexCounter;
        indexCounter++;
      });
    });
    setQuizStructure(courseStructure.data);
  };
  const startModule = async (body) => {
    const query = "api/assessments/start";
    const id_lesson_progress = await postAPI(query, body);

    const copyQuiz = [...assessment];
    copyQuiz[step + 1]["id_lesson_progress"] = id_lesson_progress.data;
    setAssessment(copyQuiz);
  };
  const handleAnswer = async (body) => {
    const query = "api/assessments/answer";
    await updateAPI(query, body);
  };
  function toggleCollapse(id) {
    const copyQuiz = [...quizStructure];
    copyQuiz[id].collapsed = !copyQuiz[id].collapsed;
    setQuizStructure(copyQuiz);
  }

  const matchAnswer = (value) => {
    setMatchedPairsState(value);
    const copyQuiz = [...assessment];
    setAssessment(copyQuiz);
    handleAnswer({
      answer_content: value,
      id_modules: copyQuiz[step].id_modules,
      id_course_enrollments: copyQuiz[step].id_course_enrollments,
    });
  };
  const answerText = (value) => {
    const copyQuiz = [...assessment];
    copyQuiz[step].module_content.quiz_answers = { "quiz_answer": value }
    setAssessment(copyQuiz);

    handleAnswer({
      answer_content: copyQuiz[step].module_content.quiz_answers,
      id_modules: copyQuiz[step].id_modules,
      id_course_enrollments: copyQuiz[step].id_course_enrollments,
    });
  };

  const clickAnswer = (index) => {
    const copyQuiz = [...assessment];
    copyQuiz[step].module_content.quiz_answers[index].chosen =
      !copyQuiz[step].module_content.quiz_answers[index].chosen;
    setAssessment(copyQuiz);
    handleAnswer({
      answer_content: copyQuiz[step].module_content.quiz_answers,
      id_modules: copyQuiz[step].id_modules,
      id_course_enrollments: copyQuiz[step].id_course_enrollments,
    });
  };
  const hasAnswers = (quiz_type) => {
    const answers = assessment[step]?.module_content?.quiz_answers;
    switch (quiz_type) {
      case 1:
      case 3:
      case 5:
        return answers?.filter(row => row.chosen === true).length > 0;
      case 2:
      case 4:
        return true;
      case 6:
        return !!answers?.quiz_answer;
      default:
        return false;
    }
  };
  const finishModule = async (body) => {
    const query = "api/assessments/finish";
    await postAPI(query, body);
  };
  const finishAssessment = async (body) => {
    if (assessment[step].preview) {
      navigationContext.handleNavigation({ ...navigationContext.sidebar, navigation: 7 })
      return
    }
    const query = "api/assessments/finish-assessment";
    const res = await postAPI(query, body);
    if (res.status === "ok") {
      setShowScoreModal(true);
    }
  }
  const goNext = async () => {

    const currentModule = assessment[step];
    const quizType = currentModule?.module_content?.quiz_type;
    const isQuiz = typeof quizType === "number";

    if (isQuiz && !hasAnswers(quizType) && !currentModule.preview) {
      toastContext.showToast(
        <>Je moet een antwoord selecteren voordat je verder kunt gaan.</>,
        "error"
      );
      return;
    }

    setAnimationClass("animate-out");
    setMessage("");
    setMessageAnimation("");

    const finishBody = {
      id_course: currentModule.id_course,
      id_course_enrollments: currentModule.id_course_enrollments,
      id_modules: currentModule.id_modules,
    };
    if (!currentModule.preview) {
      await finishModule(finishBody);
    }

    setMaxReachedModule(prev => Math.max(prev, step));

    setTimeout(async () => {
      setActiveStep(prev => prev + 1);
      setAnimationClass("animate-in");

      const nextModule = assessment[step + 1];
      if (nextModule) {
        if (currentModule.preview) return

        await startModule({
          id_course: nextModule.id_course,
          id_course_enrollments: nextModule.id_course_enrollments,
          id_modules: nextModule.id_modules,
        });
      } else {
        finishAssessment(finishBody);
      }
    }, 200);
  };


  const updateOrder = (value) => {
    handleAnswer({
      answer_content: [...value],
      id_modules: assessment[step].id_modules,
      id_course_enrollments: assessment[step].id_course_enrollments,
    });
  };

  const goBack = () => {
    if (step > 0) {
      setAnimationClass("animate-out-back");

      setTimeout(() => {
        checkForToggle(step - 1);
        setActiveStep(prev => prev - 1);
        setAnimationClass("animate-in-back");
        setMessage("");
      }, 200);
    }
  };
  const goToSection = (index) => {
    if (index <= maxReachedModule) {
      setActiveStep(index);
      setMessage("");
    } else {
      toastContext.showToast(
        <>Je kunt deze module nog niet openen — voltooi eerst de vorige.</>,
        "warning"
      );
    }
  };
  const checkForToggle = (counter) => {
    const copyStructure = [...quizStructure];
    copyStructure.forEach((section, index_id) => {
      section.collapsed = true;
      section.modules.forEach((module) => {
        if (module.indexCounter === counter && section.collapsed === true) {
          toggleCollapse(index_id);
        }
      });
    });
    setQuizStructure(copyStructure);
  };
  const [phoneCollapse, setPhoneCollapse] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [autoPlay, setAutoPlay] = useState(false);

  const isMobile = windowWidth < 768;
  const src = assessment?.[step]?.video;
  const videoSpeed = assessment?.[step]?.video_speed || 1.25;

  useEffect(() => {
    const onResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    setAvatarVideoMini(!isMobile);
  }, [isMobile]);

  const width = !avatarVideoMini ? (isMobile ? "auto" : "50%") : "100%";
  const height = src && isMobile
    ? (phoneCollapse ? "75vh" : !avatarVideoMini ? "50vh" : "")
    : (isMobile && !src ? "100dvh" : "");

  const timeExpiredMessage = "De tijd voor deze quiz is verstreken. Je antwoorden zijn automatisch ingediend.";
  const displayMessage = message || (assessment?.[step]?.on_time === false && assessment?.[step]?.time > 0 ? timeExpiredMessage : "");
  
  return (
    <>
      <ScoreOverviewModal visible={showScoreModal} onDismiss={() => setShowScoreModal(false)} />
      <VerticalLayout
        className={`quiz-assessment-grid ${assessment?.[step]?.module_type === 2 ? "text-content" : ""}`}
        style={{ alignItems: isMobile ? "start" : "center", width: "100%", flexDirection: isMobile ? "column" : "row", }}
      >
        <QuizStepper
          progressMode="section"
          activeSection={step}
          quizStructure={quizStructure}
          goToSection={(index) => goToSection(index)}
          toggleCollapse={(id) => toggleCollapse(id)}
          maxReachedModule={maxReachedModule}
          setMaxReachedModule={setMaxReachedModule}
        />
        <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", width: "100%", justifyContent: isMobile ? "flex-start" : "center", alignItems: isMobile ? "center" : "flex-start", boxSizing: "border-box", height: isMobile ?"calc(-5.5rem + 100dvh)":"calc(-8.5rem + 100dvh)" }} className={`flex quiz-step-wrapper ${animationClass}`} key={step}>
          <div style={{ marginRight: "clamp(2rem, 10vw, 10rem)", marginLeft: "clamp(2rem, 10vw, 10rem)", width: width, maxHeight: height, padding: "1rem", overflow: assessment?.[step]?.module_type === 4 ? "unset" : undefined }} data-testid="assesment-comp" className="assesment-comp-fix vertical quiz-comp phone-quiz standard-shadow standard-border">
            <AssessmentTitle
              assessment={{
                title: assessment?.[step]?.title,
                description: assessment?.[step]?.module_content?.quiz_question,
              }}
              visible={true}
            />
            <AssessmentFactory
              clickAnswer={(chosen) => clickAnswer(chosen)}
              data={assessment?.[step]?.module_content}
              module_type={assessment?.[step]?.module_type}
              updateOrder={(value) => updateOrder(value)}
              updateMatch={(value) => matchAnswer(value)}
              answerText={(value) => answerText(value)}
            />
            {assessment?.[step]?.time > 0 && assessment?.[step]?.on_time === true ? (
              <TimeBar
                time={assessment[step].time * 60}
                onTimeUp={() => {
                  setMessage("De tijd voor deze quiz is verstreken. Je antwoorden zijn automatisch ingediend.")
                  setMessageAnimation("fade-in-top-to-bottom")
                  finishModule({
                    id_course: assessment[step].id_course,
                    id_course_enrollments: assessment[step].id_course_enrollments,
                    id_modules: assessment[step].id_modules,
                  })
                }}
              />
            ) : null}
            <Melding message={displayMessage} animationClass={messageAnimation} />
          </div>
          {!avatarVideoMini && <VideoPlayerAssessment videoSpeed={videoSpeed} autoPlay={autoPlay} setCollapsed={setCollapsed} collapsed={collapsed} src={src} setPhoneCollapse={setPhoneCollapse} phoneCollapse={phoneCollapse} />}
        </div>
        {avatarVideoMini && <VideoPlayerAssessment videoSpeed={videoSpeed} autoPlay={autoPlay} setCollapsed={setCollapsed} collapsed={collapsed} src={src} setPhoneCollapse={setPhoneCollapse} phoneCollapse={phoneCollapse} />}
      
      </VerticalLayout>
      <div style={{ gridArea: "2 / 1 / 3 / 3", "padding": "1rem", "background": "var(--card-background-color)", borderTop: "1px solid var(--border-color)", marginTop: "auto" }}>
        <HorizontalLayout>
          {!isMobile && <StandardButton style={{ marginLeft: "0px" }} backgroundColor="error-600" onClick={() => navigationContext.handleNavigation({ courseID: navigationContext.sidebar.courseID, navigation: 7, enrollment: 0 })} title={<>{icon("door-exit")}</>}></StandardButton>}
           <IconButton size={24} icon2={autoPlay ? "auto-play" : "mute"} onClick={() => setAutoPlay(!autoPlay)} color={autoPlay ? "success-500" : "error-500"} style={{ marginLeft: isMobile ? "" : "auto",marginRight: isMobile ? "auto" : "" , padding: "0 1rem"}} />
          <ButtonBar style={{ width: "unset" }} next={goNext} disabled={step <= 0} back={goBack} />
        </HorizontalLayout>
      </div>
    </>
  )
};

export const QuizFactory = ({ data, clickAnswer, updateOrder, updateMatch, answerText }) => {
  switch (data?.quiz_type) {
    case 1:
      return (
        <MultipleChoice
          clickAnswer={(chosen) => clickAnswer(chosen)}
          answers={data?.quiz_answers}
        />
      );
    case 2:
      return (
        <MatchChoice
          answerContent={(value) => updateMatch(value)}
          data={data?.quiz_answers}
        />
      );
    case 3:
      return (
        <TrueFalseChoice
          clickAnswer={(chosen) => clickAnswer(chosen)}
          answers={data?.quiz_answers}
        />
      );
    case 4:
      return (
        <OrderAnswers
          updateOrder1={(value) => updateOrder(value)}
          answers={data?.quiz_answers}
        />
      );
    case 5:
      return (
        <ImageAssessmentComp
          data={data?.quiz_answers}
          onSelect={(chosenImages) => clickAnswer(chosenImages)}
        />
      );
    case 6:
      return (
        <OpenAssessmentComp
          data={data?.quiz_answers}
          answerContent={(text) => answerText(text)}
        />
      );
    default:
      return null;
  }
};
